module.exports = __webpack_public_path__ + "img/journey-email-scratch-graphical.62547fee.png";